export default function notZero(value, { locale = {} }) {
  if (parseInt(value, 10) === 0) {
    return locale.notZero || 'This field can not be 0';
  }
  return false;
}
